import React from 'react';
import styles from './styles.module.scss';

import { numberChars } from '../../../utils/format/character_restriction';

const QuantityCombo = ({ onAdd, onRemove, number, onChange }) => (
  <div className={styles.quantity}>
    <button type="button" onClick={onRemove}>
      <span>-</span>
    </button>
    <label>
      <input
        type="text"
        placeholder="1"
        onChange={onChange}
        value={number}
        onKeyPress={numberChars}
      />
    </label>
    <button type="button" onClick={onAdd}>
      <span>+</span>
    </button>
  </div>
);

export default QuantityCombo;
